import { RevealHeading, Reveal } from "../components/site/Reveal";
import { OrnateDivider, Medallion } from "../components/site/Ornaments";
import { BUSINESS, IMAGES, CHAPTERS, whatsappLink } from "../data/site";

const About = () => {
  return (
    <div data-testid="about-page" className="pt-32">
      {/* Header */}
      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="flex items-center gap-3 text-henna">
          <Medallion size={24} />
          <span className="text-xs uppercase tracking-[0.3em]">The story</span>
        </div>
        <RevealHeading
          testId="about-title"
          className="mt-6 max-w-4xl font-display text-6xl leading-[0.9] tracking-tight sm:text-7xl lg:text-8xl"
          lines={[<>Meet the</>, <span className="italic font-serif text-henna">artist</span>]}
        />
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/70">
            Arjun has spent over two decades perfecting the fine art of mehndi —
            blending traditional Rajasthani motifs with modern Arabic flow, all
            from his shop at Gandhi Chowk, Pathankot.
          </p>
        </Reveal>
      </section>

      {/* Portrait */}
      <section className="mx-auto mt-24 max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <Reveal>
          <div className="overflow-hidden rounded-sm">
            <img
              src={IMAGES.artistShop}
              alt="Arjun at his Mehndi Art studio in Pathankot with his team"
              className="h-auto w-full object-contain"
              data-testid="about-image"
            />
          </div>
          <p className="mt-3 text-xs uppercase tracking-[0.18em] text-ink/50">
            Arjun at his studio · Gandhi Chowk, Pathankot
          </p>
        </Reveal>
      </section>

      {/* Manifesto chapters */}
      <section className="mx-auto max-w-[1400px] px-5 py-28 sm:px-8 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <h2 className="font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                Craft, patience &amp; a{" "}
                <span className="italic text-henna">steady hand</span>.
              </h2>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-book-btn"
                className="mt-8 inline-block rounded-full border border-ink px-7 py-3 text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-ink hover:text-bone"
              >
                Book an appointment
              </a>
            </div>
          </div>
          <div className="lg:col-span-8">
            <div className="divide-y divide-ink/10 border-y border-ink/10">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="grid grid-cols-1 gap-4 py-12 sm:grid-cols-12">
                    <span className="font-display text-6xl text-henna/30 sm:col-span-3">
                      {c.no}
                    </span>
                    <div className="sm:col-span-9">
                      <h3 className="font-serif text-3xl">{c.title}</h3>
                      <p className="mt-3 max-w-lg text-base leading-relaxed text-ink/70">
                        {c.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats band */}
      <section className="bg-cashmere">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-8 px-5 py-16 sm:px-8 lg:grid-cols-4 lg:px-12">
          {[
            { k: "Since " + BUSINESS.established, v: "Serving Pathankot" },
            { k: BUSINESS.yearsExperience + " yrs", v: "Experience" },
            { k: BUSINESS.rating + "★", v: BUSINESS.reviews + " reviews" },
            { k: "Natural", v: "Skin-safe henna" },
          ].map((s, i) => (
            <Reveal key={s.v} delay={i * 0.07}>
              <p className="font-display text-4xl text-henna lg:text-5xl">{s.k}</p>
              <p className="mt-2 text-xs uppercase tracking-[0.15em] text-ink/50">
                {s.v}
              </p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
